import { P as te } from "./chunk.C6tu0KW1.js";
import { _ as g, a as ae, M as Tt, L as Mt } from "./chunk.Czw-e4a5.js";
import * as f from "react";
import { useTheme as st, styled as ye, useThemeProps as _e } from "@mui/material/styles";
import At from "@mui/material/Typography";
import { jsx as A, jsxs as pe } from "react/jsx-runtime";
import at from "@mui/material/IconButton";
import lt from "@mui/material/InputAdornment";
import { createSvgIcon as he } from "@mui/material/utils";
import Rt from "@mui/material/Grow";
import Lt from "@mui/material/Fade";
import Ot from "@mui/material/Paper";
import $t from "@mui/material/Popper";
import Nt from "@mui/material/Unstable_TrapFocus";
import Bt from "@mui/material/useMediaQuery";
import De from "@mui/material/Button";
import Ft from "@mui/material/DialogActions";
import _t from "@mui/material/List";
import Wt from "@mui/material/ListItem";
import zt from "@mui/material/Chip";
function Ht(e) {
  return typeof e == "string";
}
function Ut(e, t, n) {
  return e === void 0 || Ht(e) ? t : {
    ...t,
    ownerState: {
      ...t.ownerState,
      ...n
    }
  };
}
function Yt(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((o) => o.match(/^on[A-Z]/) && typeof e[o] == "function" && !t.includes(o)).forEach((o) => {
    n[o] = e[o];
  }), n;
}
function Yo(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function jt(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function Qt(...e) {
  return f.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      jt(n, t);
    });
  }, e);
}
function it(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (t = 0; t < r; t++) e[t] && (n = it(e[t])) && (o && (o += " "), o += n);
  } else for (n in e) e[n] && (o && (o += " "), o += n);
  return o;
}
function ke() {
  for (var e, t, n = 0, o = "", r = arguments.length; n < r; n++) (e = arguments[n]) && (t = it(e)) && (o && (o += " "), o += t);
  return o;
}
function Qe(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function Zt(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: o,
    externalForwardedProps: r,
    className: s
  } = e;
  if (!t) {
    const d = ke(n == null ? void 0 : n.className, s, r == null ? void 0 : r.className, o == null ? void 0 : o.className), I = {
      ...n == null ? void 0 : n.style,
      ...r == null ? void 0 : r.style,
      ...o == null ? void 0 : o.style
    }, p = {
      ...n,
      ...r,
      ...o
    };
    return d.length > 0 && (p.className = d), Object.keys(I).length > 0 && (p.style = I), {
      props: p,
      internalRef: void 0
    };
  }
  const a = Yt({
    ...r,
    ...o
  }), l = Qe(o), c = Qe(r), i = t(a), u = ke(i == null ? void 0 : i.className, n == null ? void 0 : n.className, s, r == null ? void 0 : r.className, o == null ? void 0 : o.className), v = {
    ...i == null ? void 0 : i.style,
    ...n == null ? void 0 : n.style,
    ...r == null ? void 0 : r.style,
    ...o == null ? void 0 : o.style
  }, C = {
    ...i,
    ...n,
    ...c,
    ...l
  };
  return u.length > 0 && (C.className = u), Object.keys(v).length > 0 && (C.style = v), {
    props: C,
    internalRef: i.ref
  };
}
function Gt(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function ie(e) {
  var v;
  const {
    elementType: t,
    externalSlotProps: n,
    ownerState: o,
    skipResolvingSlotProps: r = !1,
    ...s
  } = e, a = r ? {} : Gt(n, o), {
    props: l,
    internalRef: c
  } = Zt({
    ...s,
    externalSlotProps: a
  }), i = Qt(c, a == null ? void 0 : a.ref, (v = e.additionalProps) == null ? void 0 : v.ref);
  return Ut(t, {
    ...l,
    ref: i
  }, o);
}
const jo = te.oneOfType([te.func, te.object]);
function Oe(e) {
  return e && e.ownerDocument || document;
}
function Kt(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
const xe = typeof window < "u" ? f.useLayoutEffect : f.useEffect;
let Ze = 0;
function qt(e) {
  const [t, n] = f.useState(e), o = t;
  return f.useEffect(() => {
    t == null && (Ze += 1, n(`mui-${Ze}`));
  }, [t]), o;
}
const Ge = f[("useId"+"")+""];
function Xt(e) {
  return Ge !== void 0 ? Ge() : qt(e);
}
function Ce({
  controlled: e,
  default: t,
  name: n,
  state: o = "value"
}) {
  const {
    current: r
  } = f.useRef(e !== void 0), [s, a] = f.useState(t), l = r ? e : s, c = f.useCallback((i) => {
    r || a(i);
  }, []);
  return [l, c];
}
function F(e) {
  const t = f.useRef(e);
  return xe(() => {
    t.current = e;
  }), f.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
function be(...e) {
  return f.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      Kt(n, t);
    });
  }, e);
}
function Te(e, t, n = void 0) {
  const o = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (r) => {
      o[r] = e[r].reduce((s, a) => {
        if (a) {
          const l = t(a);
          l !== "" && s.push(l), n && n[a] && s.push(n[a]);
        }
        return s;
      }, []).join(" ");
    }
  ), o;
}
const Ke = (e) => e, Jt = () => {
  let e = Ke;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = Ke;
    }
  };
}, en = Jt(), tn = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function Me(e, t, n = "Mui") {
  const o = tn[t];
  return o ? `${n}-${o}` : `${en.generate(e)}-${t}`;
}
function We(e, t, n = "Mui") {
  const o = {};
  return t.forEach((r) => {
    o[r] = Me(e, r, n);
  }), o;
}
const le = (e, t) => e.length !== t.length ? !1 : t.every((n) => e.includes(n)), Qo = ({
  openTo: e,
  defaultOpenTo: t,
  views: n,
  defaultViews: o
}) => {
  const r = n ?? o;
  let s;
  if (e != null)
    s = e;
  else if (r.includes(t))
    s = t;
  else if (r.length > 0)
    s = r[0];
  else
    throw new Error("MUI: The `views` prop must contain at least one view");
  return {
    views: r,
    openTo: s
  };
}, Ne = (e, t, n) => {
  let o = t;
  return o = e.setHours(o, e.getHours(n)), o = e.setMinutes(o, e.getMinutes(n)), o = e.setSeconds(o, e.getSeconds(n)), o;
}, Zo = ({
  date: e,
  disableFuture: t,
  disablePast: n,
  maxDate: o,
  minDate: r,
  isDateDisabled: s,
  utils: a,
  timezone: l
}) => {
  const c = Ne(a, a.dateWithTimezone(void 0, l), e);
  n && a.isBefore(r, c) && (r = c), t && a.isAfter(o, c) && (o = c);
  let i = e, u = e;
  for (a.isBefore(e, r) && (i = r, u = null), a.isAfter(e, o) && (u && (u = o), i = null); i || u; ) {
    if (i && a.isAfter(i, o) && (i = null), u && a.isBefore(u, r) && (u = null), i) {
      if (!s(i))
        return i;
      i = a.addDays(i, 1);
    }
    if (u) {
      if (!s(u))
        return u;
      u = a.addDays(u, -1);
    }
  }
  return null;
}, nn = (e, t) => t == null || !e.isValid(t) ? null : t, Go = (e, t, n) => t == null || !e.isValid(t) ? n : t, on = (e, t, n) => !e.isValid(t) && t != null && !e.isValid(n) && n != null ? !0 : e.isEqual(t, n), ct = (e, t) => {
  const o = [e.startOfYear(t)];
  for (; o.length < 12; ) {
    const r = o[o.length - 1];
    o.push(e.addMonths(r, 1));
  }
  return o;
}, ut = (e, t, n) => n === "date" ? e.startOfDay(e.dateWithTimezone(void 0, t)) : e.dateWithTimezone(void 0, t), Ko = (e, t) => {
  const n = e.setHours(e.date(), t === "am" ? 2 : 14);
  return e.format(n, "meridiem");
}, rn = ["year", "month", "day"], qo = (e) => rn.includes(e), Xo = (e, {
  format: t,
  views: n
}, o) => {
  if (t != null)
    return t;
  const r = e.formats;
  return le(n, ["year"]) ? r.year : le(n, ["month"]) ? r.month : le(n, ["day"]) ? r.dayOfMonth : le(n, ["month", "year"]) ? `${r.month} ${r.year}` : le(n, ["day", "month"]) ? `${r.month} ${r.dayOfMonth}` : o ? /en/.test(e.getCurrentLocaleCode()) ? r.normalDateWithWeekday : r.normalDate : r.keyboardDate;
}, Jo = (e, t) => {
  const n = e.startOfWeek(t);
  return [0, 1, 2, 3, 4, 5, 6].map((o) => e.addDays(n, o));
}, dt = ["hours", "minutes", "seconds"], sn = (e) => dt.includes(e), er = (e) => dt.includes(e) || e === "meridiem", an = (e, t) => e ? t.getHours(e) >= 12 ? "pm" : "am" : null, ln = (e, t, n) => n && (e >= 12 ? "pm" : "am") !== t ? t === "am" ? e - 12 : e + 12 : e, cn = (e, t, n, o) => {
  const r = ln(o.getHours(e), t, n);
  return o.setHours(e, r);
}, qe = (e, t) => t.getHours(e) * 3600 + t.getMinutes(e) * 60 + t.getSeconds(e), un = (e, t) => (n, o) => e ? t.isAfter(n, o) : qe(n, t) > qe(o, t), tr = (e, {
  format: t,
  views: n,
  ampm: o
}) => {
  if (t != null)
    return t;
  const r = e.formats;
  return le(n, ["hours"]) ? o ? `${r.hours12h} ${r.meridiem}` : r.hours24h : le(n, ["minutes"]) ? r.minutes : le(n, ["seconds"]) ? r.seconds : le(n, ["minutes", "seconds"]) ? `${r.minutes}:${r.seconds}` : le(n, ["hours", "minutes", "seconds"]) ? o ? `${r.hours12h}:${r.minutes}:${r.seconds} ${r.meridiem}` : `${r.hours24h}:${r.minutes}:${r.seconds}` : o ? `${r.hours12h}:${r.minutes} ${r.meridiem}` : `${r.hours24h}:${r.minutes}`;
}, ge = {
  year: 1,
  month: 2,
  day: 3,
  hours: 4,
  minutes: 5,
  seconds: 6,
  milliseconds: 7
}, dn = (e) => Math.max(...e.map((t) => {
  var n;
  return (n = ge[t.type]) != null ? n : 1;
})), ve = (e, t, n) => {
  if (t === ge.year)
    return e.startOfYear(n);
  if (t === ge.month)
    return e.startOfMonth(n);
  if (t === ge.day)
    return e.startOfDay(n);
  let o = n;
  return t < ge.minutes && (o = e.setMinutes(o, 0)), t < ge.seconds && (o = e.setSeconds(o, 0)), t < ge.milliseconds && (o = e.setMilliseconds(o, 0)), o;
}, fn = ({
  props: e,
  utils: t,
  granularity: n,
  timezone: o,
  getTodayDate: r
}) => {
  var s;
  let a = r ? r() : ve(t, n, ut(t, o));
  e.minDate != null && t.isAfterDay(e.minDate, a) && (a = ve(t, n, e.minDate)), e.maxDate != null && t.isBeforeDay(e.maxDate, a) && (a = ve(t, n, e.maxDate));
  const l = un((s = e.disableIgnoringDatePartForTimeValidation) != null ? s : !1, t);
  return e.minTime != null && l(e.minTime, a) && (a = ve(t, n, e.disableIgnoringDatePartForTimeValidation ? e.minTime : Ne(t, a, e.minTime))), e.maxTime != null && l(a, e.maxTime) && (a = ve(t, n, e.disableIgnoringDatePartForTimeValidation ? e.maxTime : Ne(t, a, e.maxTime))), a;
}, ft = (e, t) => {
  const n = e.formatTokenMap[t];
  if (n == null)
    throw new Error([`MUI: The token "${t}" is not supported by the Date and Time Pickers.`, "Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported."].join(`
`));
  return typeof n == "string" ? {
    type: n,
    contentType: n === "meridiem" ? "letter" : "digit",
    maxLength: void 0
  } : {
    type: n.sectionType,
    contentType: n.contentType,
    maxLength: n.maxLength
  };
}, mn = (e) => {
  switch (e) {
    case "ArrowUp":
      return 1;
    case "ArrowDown":
      return -1;
    case "PageUp":
      return 5;
    case "PageDown":
      return -5;
    default:
      return 0;
  }
}, Ae = (e, t, n) => {
  const o = [], r = e.dateWithTimezone(void 0, t), s = e.startOfWeek(r), a = e.endOfWeek(r);
  let l = s;
  for (; e.isBefore(l, a); )
    o.push(l), l = e.addDays(l, 1);
  return o.map((c) => e.formatByString(c, n));
}, mt = (e, t, n, o) => {
  switch (n) {
    case "month":
      return ct(e, e.dateWithTimezone(void 0, t)).map((r) => e.formatByString(r, o));
    case "weekDay":
      return Ae(e, t, o);
    case "meridiem": {
      const r = e.dateWithTimezone(void 0, t);
      return [e.startOfDay(r), e.endOfDay(r)].map((s) => e.formatByString(s, o));
    }
    default:
      return [];
  }
}, pt = (e, t, n) => {
  let o = t;
  for (o = Number(o).toString(); o.length < n; )
    o = `0${o}`;
  return o;
}, ht = (e, t, n, o, r) => {
  if (r.type === "day" && r.contentType === "digit-with-letter") {
    const a = e.setDate(o.longestMonth, n);
    return e.formatByString(a, r.format);
  }
  const s = n.toString();
  return r.hasLeadingZerosInInput ? pt(e, s, r.maxLength) : s;
}, pn = (e, t, n, o, r, s, a) => {
  const l = mn(o), c = o === "Home", i = o === "End", u = n.value === "" || c || i, v = () => {
    const d = r[n.type]({
      currentDate: s,
      format: n.format,
      contentType: n.contentType
    }), I = (y) => ht(e, t, y, d, n), p = n.type === "minutes" && a != null && a.minutesStep ? a.minutesStep : 1;
    let h = parseInt(n.value, 10) + l * p;
    if (u) {
      if (n.type === "year" && !i && !c)
        return e.formatByString(e.dateWithTimezone(void 0, t), n.format);
      l > 0 || c ? h = d.minimum : h = d.maximum;
    }
    return h % p !== 0 && ((l < 0 || c) && (h += p - (p + h) % p), (l > 0 || i) && (h -= h % p)), h > d.maximum ? I(d.minimum + (h - d.maximum - 1) % (d.maximum - d.minimum + 1)) : h < d.minimum ? I(d.maximum - (d.minimum - h - 1) % (d.maximum - d.minimum + 1)) : I(h);
  }, C = () => {
    const d = mt(e, t, n.type, n.format);
    if (d.length === 0)
      return n.value;
    if (u)
      return l > 0 || c ? d[0] : d[d.length - 1];
    const p = (d.indexOf(n.value) + d.length + l) % d.length;
    return d[p];
  };
  return n.contentType === "digit" || n.contentType === "digit-with-letter" ? v() : C();
}, ze = (e, t) => {
  let n = e.value || e.placeholder;
  const o = t === "non-input" ? e.hasLeadingZerosInFormat : e.hasLeadingZerosInInput;
  return t === "non-input" && e.hasLeadingZerosInInput && !e.hasLeadingZerosInFormat && (n = Number(n).toString()), ["input-rtl", "input-ltr"].includes(t) && e.contentType === "digit" && !o && n.length === 1 && (n = `${n}‎`), t === "input-rtl" && (n = `⁨${n}⁩`), n;
}, Ie = (e) => e.replace(/[\u2066\u2067\u2068\u2069]/g, ""), gt = (e, t) => {
  let n = 0, o = t ? 1 : 0;
  const r = [];
  for (let s = 0; s < e.length; s += 1) {
    const a = e[s], l = ze(a, t ? "input-rtl" : "input-ltr"), c = `${a.startSeparator}${l}${a.endSeparator}`, i = Ie(c).length, u = c.length, v = Ie(l), C = o + l.indexOf(v[0]) + a.startSeparator.length, d = C + v.length;
    r.push(g({}, a, {
      start: n,
      end: n + i,
      startInInput: C,
      endInInput: d
    })), n += i, o += u;
  }
  return r;
}, hn = (e, t, n, o, r) => {
  switch (o.type) {
    case "year":
      return n.fieldYearPlaceholder({
        digitAmount: e.formatByString(e.dateWithTimezone(void 0, t), r).length,
        format: r
      });
    case "month":
      return n.fieldMonthPlaceholder({
        contentType: o.contentType,
        format: r
      });
    case "day":
      return n.fieldDayPlaceholder({
        format: r
      });
    case "weekDay":
      return n.fieldWeekDayPlaceholder({
        contentType: o.contentType,
        format: r
      });
    case "hours":
      return n.fieldHoursPlaceholder({
        format: r
      });
    case "minutes":
      return n.fieldMinutesPlaceholder({
        format: r
      });
    case "seconds":
      return n.fieldSecondsPlaceholder({
        format: r
      });
    case "meridiem":
      return n.fieldMeridiemPlaceholder({
        format: r
      });
    default:
      return r;
  }
}, Xe = (e, t, n, o) => e.formatByString(e.parse(t, n), o), yt = (e, t, n) => e.formatByString(e.dateWithTimezone(void 0, t), n).length === 4, St = (e, t, n, o, r) => {
  if (n !== "digit")
    return !1;
  const s = e.dateWithTimezone(void 0, t);
  switch (o) {
    case "year":
      return yt(e, t, r) ? e.formatByString(e.setYear(s, 1), r) === "0001" : e.formatByString(e.setYear(s, 2001), r) === "01";
    case "month":
      return e.formatByString(e.startOfYear(s), r).length > 1;
    case "day":
      return e.formatByString(e.startOfMonth(s), r).length > 1;
    case "weekDay":
      return e.formatByString(e.startOfWeek(s), r).length > 1;
    case "hours":
      return e.formatByString(e.setHours(s, 1), r).length > 1;
    case "minutes":
      return e.formatByString(e.setMinutes(s, 1), r).length > 1;
    case "seconds":
      return e.formatByString(e.setSeconds(s, 1), r).length > 1;
    default:
      throw new Error("Invalid section type");
  }
}, gn = (e, t) => {
  const n = [], {
    start: o,
    end: r
  } = e.escapedCharacters, s = new RegExp(`(\\${o}[^\\${r}]*\\${r})+`, "g");
  let a = null;
  for (; a = s.exec(t); )
    n.push({
      start: a.index,
      end: s.lastIndex - 1
    });
  return n;
}, Je = (e, t, n, o, r, s, a, l) => {
  let c = "";
  const i = [], u = e.date(), v = (m) => {
    if (m === "")
      return null;
    const S = ft(e, m), V = St(e, t, S.contentType, S.type, m), b = a ? V : S.contentType === "digit", T = r != null && e.isValid(r);
    let R = T ? e.formatByString(r, m) : "", P = null;
    if (b)
      if (V)
        P = R === "" ? e.formatByString(u, m).length : R.length;
      else {
        if (S.maxLength == null)
          throw new Error(`MUI: The token ${m} should have a 'maxDigitNumber' property on it's adapter`);
        P = S.maxLength, T && (R = pt(e, R, P));
      }
    return i.push(g({}, S, {
      format: m,
      maxLength: P,
      value: R,
      placeholder: hn(e, t, n, S, m),
      hasLeadingZeros: V,
      hasLeadingZerosInFormat: V,
      hasLeadingZerosInInput: b,
      startSeparator: i.length === 0 ? c : "",
      endSeparator: "",
      modified: !1
    })), null;
  };
  let C = 10, d = o, I = e.expandFormat(o);
  for (; I !== d; )
    if (d = I, I = e.expandFormat(d), C -= 1, C < 0)
      throw new Error("MUI: The format expansion seems to be  enter in an infinite loop. Please open an issue with the format passed to the picker component");
  const p = I, w = gn(e, p), h = new RegExp(`^(${Object.keys(e.formatTokenMap).sort((m, S) => S.length - m.length).join("|")})`, "g");
  let y = "";
  for (let m = 0; m < p.length; m += 1) {
    const S = w.find((P) => P.start <= m && P.end >= m), V = p[m], b = S != null, T = `${y}${p.slice(m)}`, R = h.test(T);
    !b && V.match(/([A-Za-z]+)/) && R ? (y = T.slice(0, h.lastIndex), m += h.lastIndex - 1) : b && (S == null ? void 0 : S.start) === m || (S == null ? void 0 : S.end) === m || (v(y), y = "", i.length === 0 ? c += V : i[i.length - 1].endSeparator += V);
  }
  return v(y), i.map((m) => {
    const S = (V) => {
      let b = V;
      return l && b !== null && b.includes(" ") && (b = `⁩${b}⁦`), s === "spacious" && ["/", ".", "-"].includes(b) && (b = ` ${b} `), b;
    };
    return m.startSeparator = S(m.startSeparator), m.endSeparator = S(m.endSeparator), m;
  });
}, yn = (e, t) => {
  const n = t.some((l) => l.type === "day"), o = [], r = [];
  for (let l = 0; l < t.length; l += 1) {
    const c = t[l];
    n && c.type === "weekDay" || (o.push(c.format), r.push(ze(c, "non-input")));
  }
  const s = o.join(" "), a = r.join(" ");
  return e.parse(a, s);
}, Sn = (e, t) => {
  const o = e.map((r) => {
    const s = ze(r, t ? "input-rtl" : "input-ltr");
    return `${r.startSeparator}${s}${r.endSeparator}`;
  }).join("");
  return t ? `⁦${o}⁩` : o;
}, Vn = (e, t) => {
  const n = e.dateWithTimezone(void 0, t), o = e.endOfYear(n), r = e.endOfDay(n), {
    maxDaysInMonth: s,
    longestMonth: a
  } = ct(e, n).reduce((l, c) => {
    const i = e.getDaysInMonth(c);
    return i > l.maxDaysInMonth ? {
      maxDaysInMonth: i,
      longestMonth: c
    } : l;
  }, {
    maxDaysInMonth: 0,
    longestMonth: null
  });
  return {
    year: ({
      format: l
    }) => ({
      minimum: 0,
      maximum: yt(e, t, l) ? 9999 : 99
    }),
    month: () => ({
      minimum: 1,
      // Assumption: All years have the same amount of months
      maximum: e.getMonth(o) + 1
    }),
    day: ({
      currentDate: l
    }) => ({
      minimum: 1,
      maximum: l != null && e.isValid(l) ? e.getDaysInMonth(l) : s,
      longestMonth: a
    }),
    weekDay: ({
      format: l,
      contentType: c
    }) => {
      if (c === "digit") {
        const i = Ae(e, t, l).map(Number);
        return {
          minimum: Math.min(...i),
          maximum: Math.max(...i)
        };
      }
      return {
        minimum: 1,
        maximum: 7
      };
    },
    hours: ({
      format: l
    }) => {
      const c = e.getHours(r);
      return e.formatByString(e.endOfDay(n), l) !== c.toString() ? {
        minimum: 1,
        maximum: Number(e.formatByString(e.startOfDay(n), l))
      } : {
        minimum: 0,
        maximum: c
      };
    },
    minutes: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of minutes
      maximum: e.getMinutes(r)
    }),
    seconds: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of seconds
      maximum: e.getSeconds(r)
    }),
    meridiem: () => ({
      minimum: 0,
      maximum: 0
    })
  };
}, In = (e, t, n, o, r) => {
  switch (n.type) {
    case "year":
      return e.setYear(r, e.getYear(o));
    case "month":
      return e.setMonth(r, e.getMonth(o));
    case "weekDay": {
      const s = Ae(e, t, n.format), a = e.formatByString(o, n.format), l = s.indexOf(a), i = s.indexOf(n.value) - l;
      return e.addDays(o, i);
    }
    case "day":
      return e.setDate(r, e.getDate(o));
    case "meridiem": {
      const s = e.getHours(o) < 12, a = e.getHours(r);
      return s && a >= 12 ? e.addHours(r, -12) : !s && a < 12 ? e.addHours(r, 12) : r;
    }
    case "hours":
      return e.setHours(r, e.getHours(o));
    case "minutes":
      return e.setMinutes(r, e.getMinutes(o));
    case "seconds":
      return e.setSeconds(r, e.getSeconds(o));
    default:
      return r;
  }
}, et = {
  year: 1,
  month: 2,
  day: 3,
  weekDay: 4,
  hours: 5,
  minutes: 6,
  seconds: 7,
  meridiem: 8
}, tt = (e, t, n, o, r, s) => (
  // cloning sections before sort to avoid mutating it
  [...o].sort((a, l) => et[a.type] - et[l.type]).reduce((a, l) => !s || l.modified ? In(e, t, l, n, a) : a, r)
), wn = () => navigator.userAgent.toLowerCase().indexOf("android") > -1, Pn = (e, t) => {
  const n = {};
  if (!t)
    return e.forEach((c, i) => {
      const u = i === 0 ? null : i - 1, v = i === e.length - 1 ? null : i + 1;
      n[i] = {
        leftIndex: u,
        rightIndex: v
      };
    }), {
      neighbors: n,
      startIndex: 0,
      endIndex: e.length - 1
    };
  const o = {}, r = {};
  let s = 0, a = 0, l = e.length - 1;
  for (; l >= 0; ) {
    a = e.findIndex(
      // eslint-disable-next-line @typescript-eslint/no-loop-func
      (c, i) => {
        var u;
        return i >= s && ((u = c.endSeparator) == null ? void 0 : u.includes(" ")) && // Special case where the spaces were not there in the initial input
        c.endSeparator !== " / ";
      }
    ), a === -1 && (a = e.length - 1);
    for (let c = a; c >= s; c -= 1)
      r[c] = l, o[l] = c, l -= 1;
    s = a + 1;
  }
  return e.forEach((c, i) => {
    const u = r[i], v = u === 0 ? null : o[u - 1], C = u === e.length - 1 ? null : o[u + 1];
    n[i] = {
      leftIndex: v,
      rightIndex: C
    };
  }), {
    neighbors: n,
    startIndex: o[0],
    endIndex: o[e.length - 1]
  };
}, vn = ["value", "referenceDate"], nr = {
  emptyValue: null,
  getTodayValue: ut,
  getInitialReferenceValue: (e) => {
    let {
      value: t,
      referenceDate: n
    } = e, o = ae(e, vn);
    return t != null && o.utils.isValid(t) ? t : n ?? fn(o);
  },
  cleanValue: nn,
  areValuesEqual: on,
  isSameError: (e, t) => e === t,
  hasError: (e) => e != null,
  defaultErrorState: null,
  getTimezone: (e, t) => t == null || !e.isValid(t) ? null : e.getTimezone(t),
  setTimezone: (e, t, n) => n == null ? null : e.setTimezone(n, t)
}, or = {
  updateReferenceValue: (e, t, n) => t == null || !e.isValid(t) ? n : t,
  getSectionsFromValue: (e, t, n, o, r) => !e.isValid(t) && !!n ? n : gt(r(t), o),
  getValueStrFromSections: Sn,
  getActiveDateManager: (e, t) => ({
    date: t.value,
    referenceDate: t.referenceValue,
    getSections: (n) => n,
    getNewValuesFromNewActiveDate: (n) => ({
      value: n,
      referenceValue: n == null || !e.isValid(n) ? t.referenceValue : n
    })
  }),
  parseValueStr: (e, t, n) => n(e.trim(), t)
}, xn = (e) => ({
  components: {
    MuiLocalizationProvider: {
      defaultProps: {
        localeText: g({}, e)
      }
    }
  }
}), Vt = {
  // Calendar navigation
  previousMonth: "Previous month",
  nextMonth: "Next month",
  // View navigation
  openPreviousView: "open previous view",
  openNextView: "open next view",
  calendarViewSwitchingButtonAriaLabel: (e) => e === "year" ? "year view is open, switch to calendar view" : "calendar view is open, switch to year view",
  // DateRange placeholders
  start: "Start",
  end: "End",
  // Action bar
  cancelButtonLabel: "Cancel",
  clearButtonLabel: "Clear",
  okButtonLabel: "OK",
  todayButtonLabel: "Today",
  // Toolbar titles
  datePickerToolbarTitle: "Select date",
  dateTimePickerToolbarTitle: "Select date & time",
  timePickerToolbarTitle: "Select time",
  dateRangePickerToolbarTitle: "Select date range",
  // Clock labels
  clockLabelText: (e, t, n) => `Select ${e}. ${t === null ? "No time selected" : `Selected time is ${n.format(t, "fullTime")}`}`,
  hoursClockNumberText: (e) => `${e} hours`,
  minutesClockNumberText: (e) => `${e} minutes`,
  secondsClockNumberText: (e) => `${e} seconds`,
  // Digital clock labels
  selectViewText: (e) => `Select ${e}`,
  // Calendar labels
  calendarWeekNumberHeaderLabel: "Week number",
  calendarWeekNumberHeaderText: "#",
  calendarWeekNumberAriaLabelText: (e) => `Week ${e}`,
  calendarWeekNumberText: (e) => `${e}`,
  // Open picker labels
  openDatePickerDialogue: (e, t) => e !== null && t.isValid(e) ? `Choose date, selected date is ${t.format(e, "fullDate")}` : "Choose date",
  openTimePickerDialogue: (e, t) => e !== null && t.isValid(e) ? `Choose time, selected time is ${t.format(e, "fullTime")}` : "Choose time",
  fieldClearLabel: "Clear value",
  // Table labels
  timeTableLabel: "pick time",
  dateTableLabel: "pick date",
  // Field section placeholders
  fieldYearPlaceholder: (e) => "Y".repeat(e.digitAmount),
  fieldMonthPlaceholder: (e) => e.contentType === "letter" ? "MMMM" : "MM",
  fieldDayPlaceholder: () => "DD",
  fieldWeekDayPlaceholder: (e) => e.contentType === "letter" ? "EEEE" : "EE",
  fieldHoursPlaceholder: () => "hh",
  fieldMinutesPlaceholder: () => "mm",
  fieldSecondsPlaceholder: () => "ss",
  fieldMeridiemPlaceholder: () => "aa"
}, Cn = Vt;
xn(Vt);
const Pe = () => {
  const e = f.useContext(Tt);
  if (e === null)
    throw new Error(["MUI: Can not find the date and time pickers localization context.", "It looks like you forgot to wrap your component in LocalizationProvider.", "This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package"].join(`
`));
  if (e.utils === null)
    throw new Error(["MUI: Can not find the date and time pickers adapter from its localization context.", "It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider."].join(`
`));
  const t = f.useMemo(() => g({}, Cn, e.localeText), [e.localeText]);
  return f.useMemo(() => g({}, e, {
    localeText: t
  }), [e, t]);
}, ce = () => Pe().utils, rr = () => Pe().defaultDates, He = () => Pe().localeText, sr = (e) => {
  const t = ce(), n = f.useRef();
  return n.current === void 0 && (n.current = t.dateWithTimezone(void 0, e)), n.current;
};
function It(e, t, n, o) {
  const {
    value: r,
    onError: s
  } = e, a = Pe(), l = f.useRef(o), c = t({
    adapter: a,
    value: r,
    props: e
  });
  return f.useEffect(() => {
    s && !n(c, l.current) && s(c, r), l.current = c;
  }, [n, s, l, c, r]), c;
}
const Ue = ({
  timezone: e,
  value: t,
  defaultValue: n,
  onChange: o,
  valueManager: r
}) => {
  var s, a;
  const l = ce(), c = f.useRef(n), i = (s = t ?? c.current) != null ? s : r.emptyValue, u = f.useMemo(() => r.getTimezone(l, i), [l, r, i]), v = F((p) => u == null ? p : r.setTimezone(l, u, p)), C = (a = e ?? u) != null ? a : "default", d = f.useMemo(() => r.setTimezone(l, C, i), [r, l, C, i]), I = F((p, ...w) => {
    const h = v(p);
    o == null || o(h, ...w);
  });
  return {
    value: d,
    handleValueChange: I,
    timezone: C
  };
}, ar = ({
  name: e,
  timezone: t,
  value: n,
  defaultValue: o,
  onChange: r,
  valueManager: s
}) => {
  const [a, l] = Ce({
    name: e,
    state: "value",
    controlled: n,
    default: o ?? s.emptyValue
  }), c = F((i, ...u) => {
    l(i), r == null || r(i, ...u);
  });
  return Ue({
    timezone: t,
    value: a,
    defaultValue: void 0,
    onChange: c,
    valueManager: s
  });
}, Dn = (e) => {
  const t = ce(), n = He(), o = Pe(), s = st().direction === "rtl", {
    valueManager: a,
    fieldValueManager: l,
    valueType: c,
    validator: i,
    internalProps: u,
    internalProps: {
      value: v,
      defaultValue: C,
      referenceDate: d,
      onChange: I,
      format: p,
      formatDensity: w = "dense",
      selectedSections: h,
      onSelectedSectionsChange: y,
      shouldRespectLeadingZeros: m = !1,
      timezone: S
    }
  } = e, {
    timezone: V,
    value: b,
    handleValueChange: T
  } = Ue({
    timezone: S,
    value: v,
    defaultValue: C,
    onChange: I,
    valueManager: a
  }), R = f.useMemo(() => Vn(t, V), [t, V]), P = f.useCallback((E, N = null) => l.getSectionsFromValue(t, E, N, s, (j) => Je(t, V, n, p, j, w, m, s)), [l, p, n, s, m, t, w, V]), H = f.useMemo(() => l.getValueStrFromSections(P(a.emptyValue), s), [l, P, a.emptyValue, s]), [k, z] = f.useState(() => {
    const E = P(b), N = {
      sections: E,
      value: b,
      referenceValue: a.emptyValue,
      tempValueStrAndroid: null
    }, j = dn(E), x = a.getInitialReferenceValue({
      referenceDate: d,
      value: b,
      utils: t,
      props: u,
      granularity: j,
      timezone: V
    });
    return g({}, N, {
      referenceValue: x
    });
  }), [B, L] = Ce({
    controlled: h,
    default: null,
    name: "useField",
    state: "selectedSectionIndexes"
  }), Y = (E) => {
    L(E), y == null || y(E), z((N) => g({}, N, {
      selectedSectionQuery: null
    }));
  }, _ = f.useMemo(() => {
    if (B == null)
      return null;
    if (B === "all")
      return {
        startIndex: 0,
        endIndex: k.sections.length - 1,
        shouldSelectBoundarySelectors: !0
      };
    if (typeof B == "number")
      return {
        startIndex: B,
        endIndex: B
      };
    if (typeof B == "string") {
      const E = k.sections.findIndex((N) => N.type === B);
      return {
        startIndex: E,
        endIndex: E
      };
    }
    return B;
  }, [B, k.sections]), U = ({
    value: E,
    referenceValue: N,
    sections: j
  }) => {
    if (z(($) => g({}, $, {
      sections: j,
      value: E,
      referenceValue: N,
      tempValueStrAndroid: null
    })), a.areValuesEqual(t, k.value, E))
      return;
    const x = {
      validationError: i({
        adapter: o,
        value: E,
        props: g({}, u, {
          value: E,
          timezone: V
        })
      })
    };
    T(E, x);
  }, O = (E, N) => {
    const j = [...k.sections];
    return j[E] = g({}, j[E], {
      value: N,
      modified: !0
    }), gt(j, s);
  }, Z = () => {
    U({
      value: a.emptyValue,
      referenceValue: k.referenceValue,
      sections: P(a.emptyValue)
    });
  }, G = () => {
    if (_ == null)
      return;
    const E = k.sections[_.startIndex], N = l.getActiveDateManager(t, k, E), x = N.getSections(k.sections).filter((J) => J.value !== "").length === (E.value === "" ? 0 : 1), $ = O(_.startIndex, ""), q = x ? null : t.date(/* @__PURE__ */ new Date("")), Q = N.getNewValuesFromNewActiveDate(q);
    (q != null && !t.isValid(q)) != (N.date != null && !t.isValid(N.date)) ? U(g({}, Q, {
      sections: $
    })) : z((J) => g({}, J, Q, {
      sections: $,
      tempValueStrAndroid: null
    }));
  }, ue = (E) => {
    const N = ($, q) => {
      const Q = t.parse($, p);
      if (Q == null || !t.isValid(Q))
        return null;
      const J = Je(t, V, n, p, Q, w, m, s);
      return tt(t, V, Q, J, q, !1);
    }, j = l.parseValueStr(E, k.referenceValue, N), x = l.updateReferenceValue(t, j, k.referenceValue);
    U({
      value: j,
      referenceValue: x,
      sections: P(j, k.sections)
    });
  }, ne = ({
    activeSection: E,
    newSectionValue: N,
    shouldGoToNextSection: j
  }) => {
    j && _ && _.startIndex < k.sections.length - 1 ? Y(_.startIndex + 1) : _ && _.startIndex !== _.endIndex && Y(_.startIndex);
    const x = l.getActiveDateManager(t, k, E), $ = O(_.startIndex, N), q = x.getSections($), Q = yn(t, q);
    let J, X;
    if (Q != null && t.isValid(Q)) {
      const ee = tt(t, V, Q, q, x.referenceDate, !0);
      J = x.getNewValuesFromNewActiveDate(ee), X = !0;
    } else
      J = x.getNewValuesFromNewActiveDate(Q), X = (Q != null && !t.isValid(Q)) != (x.date != null && !t.isValid(x.date));
    return X ? U(g({}, J, {
      sections: $
    })) : z((ee) => g({}, ee, J, {
      sections: $,
      tempValueStrAndroid: null
    }));
  }, oe = (E) => z((N) => g({}, N, {
    tempValueStrAndroid: E
  }));
  return f.useEffect(() => {
    const E = P(k.value);
    z((N) => g({}, N, {
      sections: E
    }));
  }, [p, t.locale]), f.useEffect(() => {
    let E = !1;
    a.areValuesEqual(t, k.value, b) ? E = a.getTimezone(t, k.value) !== a.getTimezone(t, b) : E = !0, E && z((N) => g({}, N, {
      value: b,
      referenceValue: l.updateReferenceValue(t, b, N.referenceValue),
      sections: P(b)
    }));
  }, [b]), {
    state: k,
    selectedSectionIndexes: _,
    setSelectedSections: Y,
    clearValue: Z,
    clearActiveSection: G,
    updateSectionValue: ne,
    updateValueFromValueStr: ue,
    setTempAndroidValueStr: oe,
    sectionsValueBoundaries: R,
    placeholder: H,
    timezone: V
  };
}, kn = 5e3, Ve = (e) => e.saveQuery != null, bn = ({
  sections: e,
  updateSectionValue: t,
  sectionsValueBoundaries: n,
  setTempAndroidValueStr: o,
  timezone: r
}) => {
  const s = ce(), [a, l] = f.useState(null), c = F(() => l(null));
  f.useEffect(() => {
    var d;
    a != null && ((d = e[a.sectionIndex]) == null ? void 0 : d.type) !== a.sectionType && c();
  }, [e, a, c]), f.useEffect(() => {
    if (a != null) {
      const d = setTimeout(() => c(), kn);
      return () => {
        window.clearTimeout(d);
      };
    }
    return () => {
    };
  }, [a, c]);
  const i = ({
    keyPressed: d,
    sectionIndex: I
  }, p, w) => {
    const h = d.toLowerCase(), y = e[I];
    if (a != null && (!w || w(a.value)) && a.sectionIndex === I) {
      const S = `${a.value}${h}`, V = p(S, y);
      if (!Ve(V))
        return l({
          sectionIndex: I,
          value: S,
          sectionType: y.type
        }), V;
    }
    const m = p(h, y);
    return Ve(m) && !m.saveQuery ? (c(), null) : (l({
      sectionIndex: I,
      value: h,
      sectionType: y.type
    }), Ve(m) ? null : m);
  }, u = (d) => {
    const I = (h, y, m) => {
      const S = y.filter((V) => V.toLowerCase().startsWith(m));
      return S.length === 0 ? {
        saveQuery: !1
      } : {
        sectionValue: S[0],
        shouldGoToNextSection: S.length === 1
      };
    }, p = (h, y, m, S) => {
      const V = (b) => mt(s, r, y.type, b);
      if (y.contentType === "letter")
        return I(y.format, V(y.format), h);
      if (m && S != null && ft(s, m).contentType === "letter") {
        const b = V(m), T = I(m, b, h);
        return Ve(T) ? {
          saveQuery: !1
        } : g({}, T, {
          sectionValue: S(T.sectionValue, b)
        });
      }
      return {
        saveQuery: !1
      };
    };
    return i(d, (h, y) => {
      switch (y.type) {
        case "month": {
          const m = (S) => Xe(s, S, s.formats.month, y.format);
          return p(h, y, s.formats.month, m);
        }
        case "weekDay": {
          const m = (S, V) => V.indexOf(S).toString();
          return p(h, y, s.formats.weekday, m);
        }
        case "meridiem":
          return p(h, y);
        default:
          return {
            saveQuery: !1
          };
      }
    });
  }, v = (d) => {
    const I = (w, h) => {
      const y = +`${w}`, m = n[h.type]({
        currentDate: null,
        format: h.format,
        contentType: h.contentType
      });
      if (y > m.maximum)
        return {
          saveQuery: !1
        };
      if (y < m.minimum)
        return {
          saveQuery: !0
        };
      const S = +`${w}0` > m.maximum || w.length === m.maximum.toString().length;
      return {
        sectionValue: ht(s, r, y, m, h),
        shouldGoToNextSection: S
      };
    };
    return i(d, (w, h) => {
      if (h.contentType === "digit" || h.contentType === "digit-with-letter")
        return I(w, h);
      if (h.type === "month") {
        const y = St(s, r, "digit", "month", "MM"), m = I(w, {
          type: h.type,
          format: "MM",
          hasLeadingZerosInFormat: y,
          hasLeadingZerosInInput: !0,
          contentType: "digit",
          maxLength: 2
        });
        if (Ve(m))
          return m;
        const S = Xe(s, m.sectionValue, "MM", h.format);
        return g({}, m, {
          sectionValue: S
        });
      }
      if (h.type === "weekDay") {
        const y = I(w, h);
        if (Ve(y))
          return y;
        const m = Ae(s, r, h.format)[Number(y.sectionValue) - 1];
        return g({}, y, {
          sectionValue: m
        });
      }
      return {
        saveQuery: !1
      };
    }, (w) => !Number.isNaN(Number(w)));
  };
  return {
    applyCharacterEditing: F((d) => {
      const I = e[d.sectionIndex], w = d.keyPressed !== " " && !Number.isNaN(Number(d.keyPressed)) ? v(d) : u(d);
      w == null ? o(null) : t({
        activeSection: I,
        newSectionValue: w.sectionValue,
        shouldGoToNextSection: w.shouldGoToNextSection
      });
    }),
    resetCharacterQuery: c
  };
};
function En(e, t) {
  return Array.isArray(t) ? t.every((n) => e.indexOf(n) !== -1) : e.indexOf(t) !== -1;
}
const lr = (e, t) => (n) => {
  (n.key === "Enter" || n.key === " ") && (e(n), n.preventDefault(), n.stopPropagation());
}, Ee = (e = document) => {
  const t = e.activeElement;
  return t ? t.shadowRoot ? Ee(t.shadowRoot) : t : null;
}, ir = "@media (pointer: fine)", Tn = ["onClick", "onKeyDown", "onFocus", "onBlur", "onMouseUp", "onPaste", "error", "clearable", "onClear", "disabled"], cr = (e) => {
  const t = ce(), {
    state: n,
    selectedSectionIndexes: o,
    setSelectedSections: r,
    clearValue: s,
    clearActiveSection: a,
    updateSectionValue: l,
    updateValueFromValueStr: c,
    setTempAndroidValueStr: i,
    sectionsValueBoundaries: u,
    placeholder: v,
    timezone: C
  } = Dn(e), {
    inputRef: d,
    internalProps: I,
    internalProps: {
      readOnly: p = !1,
      unstableFieldRef: w,
      minutesStep: h
    },
    forwardedProps: {
      onClick: y,
      onKeyDown: m,
      onFocus: S,
      onBlur: V,
      onMouseUp: b,
      onPaste: T,
      error: R,
      clearable: P,
      onClear: H,
      disabled: k
    },
    fieldValueManager: z,
    valueManager: B,
    validator: L
  } = e, Y = ae(e.forwardedProps, Tn), {
    applyCharacterEditing: _,
    resetCharacterQuery: U
  } = bn({
    sections: n.sections,
    updateSectionValue: l,
    sectionsValueBoundaries: u,
    setTempAndroidValueStr: i,
    timezone: C
  }), O = f.useRef(null), Z = be(d, O), G = f.useRef(void 0), ne = st().direction === "rtl", oe = f.useMemo(() => Pn(n.sections, ne), [n.sections, ne]), E = () => {
    var D;
    if (p) {
      r(null);
      return;
    }
    const M = (D = O.current.selectionStart) != null ? D : 0;
    let W;
    M <= n.sections[0].startInInput || M >= n.sections[n.sections.length - 1].endInInput ? W = 1 : W = n.sections.findIndex((re) => re.startInInput - re.startSeparator.length > M);
    const K = W === -1 ? n.sections.length - 1 : W - 1;
    r(K);
  }, N = F((D, ...M) => {
    D.isDefaultPrevented() || (y == null || y(D, ...M), E());
  }), j = F((D) => {
    b == null || b(D), D.preventDefault();
  }), x = F((...D) => {
    S == null || S(...D);
    const M = O.current;
    window.clearTimeout(G.current), G.current = setTimeout(() => {
      !M || M !== O.current || o != null || p || (// avoid selecting all sections when focusing empty field without value
      M.value.length && Number(M.selectionEnd) - Number(M.selectionStart) === M.value.length ? r("all") : E());
    });
  }), $ = F((...D) => {
    V == null || V(...D), r(null);
  }), q = F((D) => {
    if (T == null || T(D), p) {
      D.preventDefault();
      return;
    }
    const M = D.clipboardData.getData("text");
    if (o && o.startIndex === o.endIndex) {
      const W = n.sections[o.startIndex], K = /^[a-zA-Z]+$/.test(M), re = /^[0-9]+$/.test(M), se = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(M);
      if (W.contentType === "letter" && K || W.contentType === "digit" && re || W.contentType === "digit-with-letter" && se) {
        U(), l({
          activeSection: W,
          newSectionValue: M,
          shouldGoToNextSection: !0
        }), D.preventDefault();
        return;
      }
      if (K || re) {
        D.preventDefault();
        return;
      }
    }
    D.preventDefault(), U(), c(M);
  }), Q = F((D) => {
    if (p)
      return;
    const M = D.target.value;
    if (M === "") {
      U(), s();
      return;
    }
    const W = D.nativeEvent.data, K = W && W.length > 1, re = K ? W : M, se = Ie(re);
    if (o == null || K) {
      c(K ? W : se);
      return;
    }
    let fe;
    if (o.startIndex === 0 && o.endIndex === n.sections.length - 1 && se.length === 1)
      fe = se;
    else {
      const de = Ie(z.getValueStrFromSections(n.sections, ne));
      let Re = -1, Le = -1;
      for (let me = 0; me < de.length; me += 1)
        Re === -1 && de[me] !== se[me] && (Re = me), Le === -1 && de[de.length - me - 1] !== se[se.length - me - 1] && (Le = me);
      const Se = n.sections[o.startIndex];
      if (Re < Se.start || de.length - Le - 1 > Se.end)
        return;
      const Et = se.length - de.length + Se.end - Ie(Se.endSeparator || "").length;
      fe = se.slice(Se.start + Ie(Se.startSeparator || "").length, Et);
    }
    if (fe.length === 0) {
      wn() ? i(re) : (U(), a());
      return;
    }
    _({
      keyPressed: fe,
      sectionIndex: o.startIndex
    });
  }), J = F((D) => {
    switch (m == null || m(D), !0) {
      case (D.key === "a" && (D.ctrlKey || D.metaKey)): {
        D.preventDefault(), r("all");
        break;
      }
      case D.key === "ArrowRight": {
        if (D.preventDefault(), o == null)
          r(oe.startIndex);
        else if (o.startIndex !== o.endIndex)
          r(o.endIndex);
        else {
          const M = oe.neighbors[o.startIndex].rightIndex;
          M !== null && r(M);
        }
        break;
      }
      case D.key === "ArrowLeft": {
        if (D.preventDefault(), o == null)
          r(oe.endIndex);
        else if (o.startIndex !== o.endIndex)
          r(o.startIndex);
        else {
          const M = oe.neighbors[o.startIndex].leftIndex;
          M !== null && r(M);
        }
        break;
      }
      case D.key === "Delete": {
        if (D.preventDefault(), p)
          break;
        o == null || o.startIndex === 0 && o.endIndex === n.sections.length - 1 ? s() : a(), U();
        break;
      }
      case ["ArrowUp", "ArrowDown", "Home", "End", "PageUp", "PageDown"].includes(D.key): {
        if (D.preventDefault(), p || o == null)
          break;
        const M = n.sections[o.startIndex], W = z.getActiveDateManager(t, n, M), K = pn(t, C, M, D.key, u, W.date, {
          minutesStep: h
        });
        l({
          activeSection: M,
          newSectionValue: K,
          shouldGoToNextSection: !1
        });
        break;
      }
    }
  });
  xe(() => {
    if (!O.current)
      return;
    if (o == null) {
      O.current.scrollLeft && (O.current.scrollLeft = 0);
      return;
    }
    const D = n.sections[o.startIndex], M = n.sections[o.endIndex];
    let W = D.startInInput, K = M.endInInput;
    if (o.shouldSelectBoundarySelectors && (W -= D.startSeparator.length, K += M.endSeparator.length), W !== O.current.selectionStart || K !== O.current.selectionEnd) {
      const re = O.current.scrollTop;
      O.current === Ee(document) && O.current.setSelectionRange(W, K), O.current.scrollTop = re;
    }
  });
  const X = It(g({}, I, {
    value: n.value,
    timezone: C
  }), L, B.isSameError, B.defaultErrorState), ee = f.useMemo(() => R !== void 0 ? R : B.hasError(X), [B, X, R]);
  f.useEffect(() => {
    !ee && !o && U();
  }, [n.referenceValue, o, ee]), f.useEffect(() => (O.current && O.current === document.activeElement && r("all"), () => window.clearTimeout(G.current)), []), f.useEffect(() => {
    n.tempValueStrAndroid != null && o != null && (U(), a());
  }, [n.tempValueStrAndroid]);
  const Ye = f.useMemo(() => {
    var D;
    return (D = n.tempValueStrAndroid) != null ? D : z.getValueStrFromSections(n.sections, ne);
  }, [n.sections, z, n.tempValueStrAndroid, ne]), Ct = f.useMemo(() => o == null || n.sections[o.startIndex].contentType === "letter" ? "text" : "numeric", [o, n.sections]), Dt = O.current && O.current === Ee(document), je = B.areValuesEqual(t, n.value, B.emptyValue), kt = !Dt && je;
  f.useImperativeHandle(w, () => ({
    getSections: () => n.sections,
    getActiveSectionIndex: () => {
      var D, M, W;
      const K = (D = O.current.selectionStart) != null ? D : 0, re = (M = O.current.selectionEnd) != null ? M : 0, se = !!((W = O.current) != null && W.readOnly);
      if (K === 0 && re === 0 || se)
        return null;
      const fe = K <= n.sections[0].startInInput ? 1 : n.sections.findIndex((de) => de.startInInput - de.startSeparator.length > K);
      return fe === -1 ? n.sections.length - 1 : fe - 1;
    },
    setSelectedSections: (D) => r(D)
  }));
  const bt = F((D, ...M) => {
    var W;
    D.preventDefault(), H == null || H(D, ...M), s(), O == null || (W = O.current) == null || W.focus(), r(0);
  });
  return g({
    placeholder: v,
    autoComplete: "off",
    disabled: !!k
  }, Y, {
    value: kt ? "" : Ye,
    inputMode: Ct,
    readOnly: p,
    onClick: N,
    onFocus: x,
    onBlur: $,
    onPaste: q,
    onChange: Q,
    onKeyDown: J,
    onMouseUp: j,
    onClear: bt,
    error: ee,
    ref: Z,
    clearable: !!(P && !je && !p && !k)
  });
}, Be = ["disablePast", "disableFuture", "minDate", "maxDate", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear"], Fe = ["disablePast", "disableFuture", "minTime", "maxTime", "shouldDisableClock", "shouldDisableTime", "minutesStep", "ampm", "disableIgnoringDatePartForTimeValidation"], wt = ["minDateTime", "maxDateTime"], Mn = [...Be, ...Fe, ...wt], ur = (e) => Mn.reduce((t, n) => (e.hasOwnProperty(n) && (t[n] = e[n]), t), {}), An = ["value", "defaultValue", "referenceDate", "format", "formatDensity", "onChange", "timezone", "readOnly", "onError", "shouldRespectLeadingZeros", "selectedSections", "onSelectedSectionsChange", "unstableFieldRef"], dr = (e, t) => {
  const n = g({}, e), o = {}, r = (s) => {
    n.hasOwnProperty(s) && (o[s] = n[s], delete n[s]);
  };
  return An.forEach(r), t === "date" ? Be.forEach(r) : t === "time" ? Fe.forEach(r) : t === "date-time" && (Be.forEach(r), Fe.forEach(r), wt.forEach(r)), {
    forwardedProps: n,
    internalProps: o
  };
}, fr = he(/* @__PURE__ */ A("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown"), mr = he(/* @__PURE__ */ A("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "ArrowLeft"), pr = he(/* @__PURE__ */ A("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "ArrowRight"), hr = he(/* @__PURE__ */ A("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), "Calendar"), gr = he(/* @__PURE__ */ pe(f.Fragment, {
  children: [/* @__PURE__ */ A("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ A("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Clock"), yr = he(/* @__PURE__ */ A("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), "DateRange"), Sr = he(/* @__PURE__ */ pe(f.Fragment, {
  children: [/* @__PURE__ */ A("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ A("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Time"), Rn = he(/* @__PURE__ */ A("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear"), Vr = 36, Ir = 2, Ln = 320, wr = 280, Pt = 334, Pr = 232, vr = 48;
function On(e) {
  return Me("MuiPickersPopper", e);
}
We("MuiPickersPopper", ["root", "paper"]);
const $n = "@media (prefers-reduced-motion: reduce)", we = typeof navigator < "u" && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i), nt = we && we[1] ? parseInt(we[1], 10) : null, ot = we && we[2] ? parseInt(we[2], 10) : null, Nn = nt && nt < 10 || ot && ot < 13 || !1, Bn = () => Bt($n, {
  defaultMatches: !1
}) || Nn, Fn = ["PaperComponent", "popperPlacement", "ownerState", "children", "paperSlotProps", "paperClasses", "onPaperClick", "onPaperTouchStart"], _n = (e) => {
  const {
    classes: t
  } = e;
  return Te({
    root: ["root"],
    paper: ["paper"]
  }, On, t);
}, Wn = ye($t, {
  name: "MuiPickersPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  zIndex: e.zIndex.modal
})), zn = ye(Ot, {
  name: "MuiPickersPopper",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})(({
  ownerState: e
}) => g({
  outline: 0,
  transformOrigin: "top center"
}, e.placement.includes("top") && {
  transformOrigin: "bottom center"
}));
function Hn(e, t) {
  return t.documentElement.clientWidth < e.clientX || t.documentElement.clientHeight < e.clientY;
}
function Un(e, t) {
  const n = f.useRef(!1), o = f.useRef(!1), r = f.useRef(null), s = f.useRef(!1);
  f.useEffect(() => {
    if (!e)
      return;
    function c() {
      s.current = !0;
    }
    return document.addEventListener("mousedown", c, !0), document.addEventListener("touchstart", c, !0), () => {
      document.removeEventListener("mousedown", c, !0), document.removeEventListener("touchstart", c, !0), s.current = !1;
    };
  }, [e]);
  const a = F((c) => {
    if (!s.current)
      return;
    const i = o.current;
    o.current = !1;
    const u = Oe(r.current);
    if (!r.current || // is a TouchEvent?
    "clientX" in c && Hn(c, u))
      return;
    if (n.current) {
      n.current = !1;
      return;
    }
    let v;
    c.composedPath ? v = c.composedPath().indexOf(r.current) > -1 : v = !u.documentElement.contains(c.target) || r.current.contains(c.target), !v && !i && t(c);
  }), l = () => {
    o.current = !0;
  };
  return f.useEffect(() => {
    if (e) {
      const c = Oe(r.current), i = () => {
        n.current = !0;
      };
      return c.addEventListener("touchstart", a), c.addEventListener("touchmove", i), () => {
        c.removeEventListener("touchstart", a), c.removeEventListener("touchmove", i);
      };
    }
  }, [e, a]), f.useEffect(() => {
    if (e) {
      const c = Oe(r.current);
      return c.addEventListener("click", a), () => {
        c.removeEventListener("click", a), o.current = !1;
      };
    }
  }, [e, a]), [r, l, l];
}
const Yn = /* @__PURE__ */ f.forwardRef((e, t) => {
  const {
    PaperComponent: n,
    popperPlacement: o,
    ownerState: r,
    children: s,
    paperSlotProps: a,
    paperClasses: l,
    onPaperClick: c,
    onPaperTouchStart: i
    // picks up the style props provided by `Transition`
    // https://mui.com/material-ui/transitions/#child-requirement
  } = e, u = ae(e, Fn), v = g({}, r, {
    placement: o
  }), C = ie({
    elementType: n,
    externalSlotProps: a,
    additionalProps: {
      tabIndex: -1,
      elevation: 8,
      ref: t
    },
    className: l,
    ownerState: v
  });
  return /* @__PURE__ */ A(n, g({}, u, C, {
    onClick: (d) => {
      var I;
      c(d), (I = C.onClick) == null || I.call(C, d);
    },
    onTouchStart: (d) => {
      var I;
      i(d), (I = C.onTouchStart) == null || I.call(C, d);
    },
    ownerState: v,
    children: s
  }));
});
function jn(e) {
  var t, n, o, r;
  const s = _e({
    props: e,
    name: "MuiPickersPopper"
  }), {
    anchorEl: a,
    children: l,
    containerRef: c = null,
    shouldRestoreFocus: i,
    onBlur: u,
    onDismiss: v,
    open: C,
    role: d,
    placement: I,
    slots: p,
    slotProps: w,
    reduceAnimations: h
  } = s;
  f.useEffect(() => {
    function Z(G) {
      C && (G.key === "Escape" || G.key === "Esc") && v();
    }
    return document.addEventListener("keydown", Z), () => {
      document.removeEventListener("keydown", Z);
    };
  }, [v, C]);
  const y = f.useRef(null);
  f.useEffect(() => {
    d === "tooltip" || i && !i() || (C ? y.current = Ee(document) : y.current && y.current instanceof HTMLElement && setTimeout(() => {
      y.current instanceof HTMLElement && y.current.focus();
    }));
  }, [C, d, i]);
  const [m, S, V] = Un(C, u ?? v), b = f.useRef(null), T = be(b, c), R = be(T, m), P = s, H = _n(P), k = Bn(), z = h ?? k, B = (Z) => {
    Z.key === "Escape" && (Z.stopPropagation(), v());
  }, L = ((t = p == null ? void 0 : p.desktopTransition) != null ? t : z) ? Lt : Rt, Y = (n = p == null ? void 0 : p.desktopTrapFocus) != null ? n : Nt, _ = (o = p == null ? void 0 : p.desktopPaper) != null ? o : zn, U = (r = p == null ? void 0 : p.popper) != null ? r : Wn, O = ie({
    elementType: U,
    externalSlotProps: w == null ? void 0 : w.popper,
    additionalProps: {
      transition: !0,
      role: d,
      open: C,
      anchorEl: a,
      placement: I,
      onKeyDown: B
    },
    className: H.root,
    ownerState: s
  });
  return /* @__PURE__ */ A(U, g({}, O, {
    children: ({
      TransitionProps: Z,
      placement: G
    }) => /* @__PURE__ */ A(Y, g({
      open: C,
      disableAutoFocus: !0,
      disableRestoreFocus: !0,
      disableEnforceFocus: d === "tooltip",
      isEnabled: () => !0
    }, w == null ? void 0 : w.desktopTrapFocus, {
      children: /* @__PURE__ */ A(L, g({}, Z, w == null ? void 0 : w.desktopTransition, {
        children: /* @__PURE__ */ A(Yn, {
          PaperComponent: _,
          ownerState: P,
          popperPlacement: G,
          ref: R,
          onPaperClick: S,
          onPaperTouchStart: V,
          paperClasses: H.paper,
          paperSlotProps: w == null ? void 0 : w.desktopPaper,
          children: l
        })
      }))
    }))
  }));
}
function Qn(e) {
  return Me("MuiPickersToolbar", e);
}
We("MuiPickersToolbar", ["root", "content"]);
const Zn = (e) => {
  const {
    classes: t,
    isLandscape: n
  } = e;
  return Te({
    root: ["root"],
    content: ["content"],
    penIconButton: ["penIconButton", n && "penIconButtonLandscape"]
  }, Qn, t);
}, Gn = ye("div", {
  name: "MuiPickersToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => g({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  padding: e.spacing(2, 3)
}, t.isLandscape && {
  height: "auto",
  maxWidth: 160,
  padding: 16,
  justifyContent: "flex-start",
  flexWrap: "wrap"
})), Kn = ye("div", {
  name: "MuiPickersToolbar",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})(({
  ownerState: e
}) => {
  var t;
  return {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    justifyContent: e.isLandscape ? "flex-start" : "space-between",
    flexDirection: e.isLandscape ? (t = e.landscapeDirection) != null ? t : "column" : "row",
    flex: 1,
    alignItems: e.isLandscape ? "flex-start" : "center"
  };
}), xr = /* @__PURE__ */ f.forwardRef(function(t, n) {
  const o = _e({
    props: t,
    name: "MuiPickersToolbar"
  }), {
    children: r,
    className: s,
    toolbarTitle: a,
    hidden: l,
    titleId: c
  } = o, i = o, u = Zn(i);
  return l ? null : /* @__PURE__ */ pe(Gn, {
    ref: n,
    className: ke(u.root, s),
    ownerState: i,
    children: [/* @__PURE__ */ A(At, {
      color: "text.secondary",
      variant: "overline",
      id: c,
      children: a
    }), /* @__PURE__ */ A(Kn, {
      className: u.content,
      ownerState: i,
      children: r
    })]
  });
}), qn = ({
  open: e,
  onOpen: t,
  onClose: n
}) => {
  const o = f.useRef(typeof e == "boolean").current, [r, s] = f.useState(!1);
  f.useEffect(() => {
    if (o) {
      if (typeof e != "boolean")
        throw new Error("You must not mix controlling and uncontrolled mode for `open` prop");
      s(e);
    }
  }, [o, e]);
  const a = f.useCallback((l) => {
    o || s(l), l && t && t(), !l && n && n();
  }, [o, t, n]);
  return {
    isOpen: r,
    setIsOpen: a
  };
}, Xn = (e) => {
  const {
    action: t,
    hasChanged: n,
    dateState: o,
    isControlled: r
  } = e, s = !r && !o.hasBeenModifiedSinceMount;
  return t.name === "setValueFromField" ? !0 : t.name === "setValueFromAction" ? s && ["accept", "today", "clear"].includes(t.pickerAction) ? !0 : n(o.lastPublishedValue) : t.name === "setValueFromView" && t.selectionState !== "shallow" || t.name === "setValueFromShortcut" ? s ? !0 : n(o.lastPublishedValue) : !1;
}, Jn = (e) => {
  const {
    action: t,
    hasChanged: n,
    dateState: o,
    isControlled: r,
    closeOnSelect: s
  } = e, a = !r && !o.hasBeenModifiedSinceMount;
  return t.name === "setValueFromAction" ? a && ["accept", "today", "clear"].includes(t.pickerAction) ? !0 : n(o.lastCommittedValue) : t.name === "setValueFromView" && t.selectionState === "finish" && s ? a ? !0 : n(o.lastCommittedValue) : t.name === "setValueFromShortcut" ? t.changeImportance === "accept" && n(o.lastCommittedValue) : !1;
}, eo = (e) => {
  const {
    action: t,
    closeOnSelect: n
  } = e;
  return t.name === "setValueFromAction" ? !0 : t.name === "setValueFromView" ? t.selectionState === "finish" && n : t.name === "setValueFromShortcut" ? t.changeImportance === "accept" : !1;
}, to = ({
  props: e,
  valueManager: t,
  valueType: n,
  wrapperVariant: o,
  validator: r
}) => {
  const {
    onAccept: s,
    onChange: a,
    value: l,
    defaultValue: c,
    closeOnSelect: i = o === "desktop",
    selectedSections: u,
    onSelectedSectionsChange: v,
    timezone: C
  } = e, {
    current: d
  } = f.useRef(c), {
    current: I
  } = f.useRef(l !== void 0), p = ce(), w = Pe(), [h, y] = Ce({
    controlled: u,
    default: null,
    name: "usePickerValue",
    state: "selectedSections"
  }), {
    isOpen: m,
    setIsOpen: S
  } = qn(e), [V, b] = f.useState(() => {
    let x;
    return l !== void 0 ? x = l : d !== void 0 ? x = d : x = t.emptyValue, {
      draft: x,
      lastPublishedValue: x,
      lastCommittedValue: x,
      lastControlledValue: l,
      hasBeenModifiedSinceMount: !1
    };
  }), {
    timezone: T,
    handleValueChange: R
  } = Ue({
    timezone: C,
    value: l,
    defaultValue: d,
    onChange: a,
    valueManager: t
  });
  It(g({}, e, {
    value: V.draft,
    timezone: T
  }), r, t.isSameError, t.defaultErrorState);
  const P = F((x) => {
    const $ = {
      action: x,
      dateState: V,
      hasChanged: (X) => !t.areValuesEqual(p, x.value, X),
      isControlled: I,
      closeOnSelect: i
    }, q = Xn($), Q = Jn($), J = eo($);
    if (b((X) => g({}, X, {
      draft: x.value,
      lastPublishedValue: q ? x.value : X.lastPublishedValue,
      lastCommittedValue: Q ? x.value : X.lastCommittedValue,
      hasBeenModifiedSinceMount: !0
    })), q) {
      const ee = {
        validationError: x.name === "setValueFromField" ? x.context.validationError : r({
          adapter: w,
          value: x.value,
          props: g({}, e, {
            value: x.value,
            timezone: T
          })
        })
      };
      x.name === "setValueFromShortcut" && x.shortcut != null && (ee.shortcut = x.shortcut), R(x.value, ee);
    }
    Q && s && s(x.value), J && S(!1);
  });
  if (l !== void 0 && (V.lastControlledValue === void 0 || !t.areValuesEqual(p, V.lastControlledValue, l))) {
    const x = t.areValuesEqual(p, V.draft, l);
    b(($) => g({}, $, {
      lastControlledValue: l
    }, x ? {} : {
      lastCommittedValue: l,
      lastPublishedValue: l,
      draft: l,
      hasBeenModifiedSinceMount: !0
    }));
  }
  const H = F(() => {
    P({
      value: t.emptyValue,
      name: "setValueFromAction",
      pickerAction: "clear"
    });
  }), k = F(() => {
    P({
      value: V.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "accept"
    });
  }), z = F(() => {
    P({
      value: V.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "dismiss"
    });
  }), B = F(() => {
    P({
      value: V.lastCommittedValue,
      name: "setValueFromAction",
      pickerAction: "cancel"
    });
  }), L = F(() => {
    P({
      value: t.getTodayValue(p, T, n),
      name: "setValueFromAction",
      pickerAction: "today"
    });
  }), Y = F(() => S(!0)), _ = F(() => S(!1)), U = F((x, $ = "partial") => P({
    name: "setValueFromView",
    value: x,
    selectionState: $
  })), O = F((x, $, q) => P({
    name: "setValueFromShortcut",
    value: x,
    changeImportance: $ ?? "accept",
    shortcut: q
  })), Z = F((x, $) => P({
    name: "setValueFromField",
    value: x,
    context: $
  })), G = F((x) => {
    y(x), v == null || v(x);
  }), ue = {
    onClear: H,
    onAccept: k,
    onDismiss: z,
    onCancel: B,
    onSetToday: L,
    onOpen: Y,
    onClose: _
  }, ne = {
    value: V.draft,
    onChange: Z,
    selectedSections: h,
    onSelectedSectionsChange: G
  }, oe = f.useMemo(() => t.cleanValue(p, V.draft), [p, t, V.draft]), E = {
    value: oe,
    onChange: U,
    onClose: _,
    open: m,
    onSelectedSectionsChange: G
  }, j = g({}, ue, {
    value: oe,
    onChange: U,
    onSelectShortcut: O,
    isValid: (x) => {
      const $ = r({
        adapter: w,
        value: x,
        props: g({}, e, {
          value: x,
          timezone: T
        })
      });
      return !t.hasError($);
    }
  });
  return {
    open: m,
    fieldProps: ne,
    viewProps: E,
    layoutProps: j,
    actions: ue
  };
};
function no({
  onChange: e,
  onViewChange: t,
  openTo: n,
  view: o,
  views: r,
  autoFocus: s,
  focusedView: a,
  onFocusedViewChange: l
}) {
  var c, i;
  const u = f.useRef(n), v = f.useRef(r), C = f.useRef(r.includes(n) ? n : r[0]), [d, I] = Ce({
    name: "useViews",
    state: "view",
    controlled: o,
    default: C.current
  }), p = f.useRef(s ? d : null), [w, h] = Ce({
    name: "useViews",
    state: "focusedView",
    controlled: a,
    default: p.current
  });
  f.useEffect(() => {
    (u.current && u.current !== n || v.current && v.current.some((P) => !r.includes(P))) && (I(r.includes(n) ? n : r[0]), v.current = r, u.current = n);
  }, [n, I, d, r]);
  const y = r.indexOf(d), m = (c = r[y - 1]) != null ? c : null, S = (i = r[y + 1]) != null ? i : null, V = F((P, H) => {
    h(H ? P : (k) => P === k ? null : k), l == null || l(P, H);
  }), b = F((P) => {
    V(P, !0), P !== d && (I(P), t && t(P));
  }), T = F(() => {
    S && b(S);
  }), R = F((P, H, k) => {
    const z = H === "finish", B = k ? (
      // handles case like `DateTimePicker`, where a view might return a `finish` selection state
      // but we it's not the final view given all `views` -> overall selection state should be `partial`.
      r.indexOf(k) < r.length - 1
    ) : !!S;
    if (e(P, z && B ? "partial" : H, k), k && k !== d) {
      const Y = r[r.indexOf(k) + 1];
      Y && b(Y);
    } else z && T();
  });
  return {
    view: d,
    setView: b,
    focusedView: w,
    setFocusedView: V,
    nextView: S,
    previousView: m,
    // Always return up to date default view instead of the initial one (i.e. defaultView.current)
    defaultView: r.includes(n) ? n : r[0],
    goToNextView: T,
    setValueAndGoToNextView: R
  };
}
const oo = ["className", "sx"], ro = ({
  props: e,
  propsFromPickerValue: t,
  additionalViewProps: n,
  inputRef: o,
  autoFocusView: r
}) => {
  const {
    onChange: s,
    open: a,
    onSelectedSectionsChange: l,
    onClose: c
  } = t, {
    view: i,
    views: u,
    openTo: v,
    onViewChange: C,
    viewRenderers: d,
    timezone: I
  } = e, p = ae(e, oo), {
    view: w,
    setView: h,
    defaultView: y,
    focusedView: m,
    setFocusedView: S,
    setValueAndGoToNextView: V
  } = no({
    view: i,
    views: u,
    openTo: v,
    onChange: s,
    onViewChange: C,
    autoFocus: r
  }), {
    hasUIView: b,
    viewModeLookup: T
  } = f.useMemo(() => u.reduce((L, Y) => {
    let _;
    return d[Y] != null ? _ = "UI" : _ = "field", L.viewModeLookup[Y] = _, _ === "UI" && (L.hasUIView = !0), L;
  }, {
    hasUIView: !1,
    viewModeLookup: {}
  }), [d, u]), R = f.useMemo(() => u.reduce((L, Y) => d[Y] != null && sn(Y) ? L + 1 : L, 0), [d, u]), P = T[w], H = F(() => P === "UI"), [k, z] = f.useState(P === "UI" ? w : null);
  return k !== w && T[w] === "UI" && z(w), xe(() => {
    P === "field" && a && (c(), setTimeout(() => {
      o == null || o.current.focus(), l(w);
    }));
  }, [w]), xe(() => {
    if (!a)
      return;
    let L = w;
    P === "field" && k != null && (L = k), L !== y && T[L] === "UI" && T[y] === "UI" && (L = y), L !== w && h(L), S(L, !0);
  }, [a]), {
    hasUIView: b,
    shouldRestoreFocus: H,
    layoutProps: {
      views: u,
      view: k,
      onViewChange: h
    },
    renderCurrentView: () => {
      if (k == null)
        return null;
      const L = d[k];
      return L == null ? null : L(g({}, p, n, t, {
        views: u,
        timezone: I,
        onChange: V,
        view: k,
        onViewChange: h,
        focusedView: m,
        onFocusedViewChange: S,
        showViewSwitcher: R > 1,
        timeViewsCount: R
      }));
    }
  };
};
function rt() {
  return typeof window > "u" ? "portrait" : window.screen && window.screen.orientation && window.screen.orientation.angle ? Math.abs(window.screen.orientation.angle) === 90 ? "landscape" : "portrait" : window.orientation && Math.abs(Number(window.orientation)) === 90 ? "landscape" : "portrait";
}
const so = (e, t) => {
  const [n, o] = f.useState(rt);
  return xe(() => {
    const s = () => {
      o(rt());
    };
    return window.addEventListener("orientationchange", s), () => {
      window.removeEventListener("orientationchange", s);
    };
  }, []), En(e, ["hours", "minutes", "seconds"]) ? !1 : (t || n) === "landscape";
}, ao = ({
  props: e,
  propsFromPickerValue: t,
  propsFromPickerViews: n,
  wrapperVariant: o
}) => {
  const {
    orientation: r
  } = e, s = so(n.views, r);
  return {
    layoutProps: g({}, n, t, {
      isLandscape: s,
      wrapperVariant: o,
      disabled: e.disabled,
      readOnly: e.readOnly
    })
  };
}, lo = ({
  props: e,
  valueManager: t,
  valueType: n,
  wrapperVariant: o,
  inputRef: r,
  additionalViewProps: s,
  validator: a,
  autoFocusView: l
}) => {
  const c = to({
    props: e,
    valueManager: t,
    valueType: n,
    wrapperVariant: o,
    validator: a
  }), i = ro({
    props: e,
    inputRef: r,
    additionalViewProps: s,
    autoFocusView: l,
    propsFromPickerValue: c.viewProps
  }), u = ao({
    props: e,
    wrapperVariant: o,
    propsFromPickerValue: c.layoutProps,
    propsFromPickerViews: i.layoutProps
  });
  return {
    // Picker value
    open: c.open,
    actions: c.actions,
    fieldProps: c.fieldProps,
    // Picker views
    renderCurrentView: i.renderCurrentView,
    hasUIView: i.hasUIView,
    shouldRestoreFocus: i.shouldRestoreFocus,
    // Picker layout
    layoutProps: u.layoutProps
  };
};
function vt(e) {
  return Me("MuiPickersLayout", e);
}
const $e = We("MuiPickersLayout", ["root", "landscape", "contentWrapper", "toolbar", "actionBar", "tabs", "shortcuts"]), io = ["onAccept", "onClear", "onCancel", "onSetToday", "actions"];
function co(e) {
  const {
    onAccept: t,
    onClear: n,
    onCancel: o,
    onSetToday: r,
    actions: s
  } = e, a = ae(e, io), l = He();
  if (s == null || s.length === 0)
    return null;
  const c = s == null ? void 0 : s.map((i) => {
    switch (i) {
      case "clear":
        return /* @__PURE__ */ A(De, {
          onClick: n,
          children: l.clearButtonLabel
        }, i);
      case "cancel":
        return /* @__PURE__ */ A(De, {
          onClick: o,
          children: l.cancelButtonLabel
        }, i);
      case "accept":
        return /* @__PURE__ */ A(De, {
          onClick: t,
          children: l.okButtonLabel
        }, i);
      case "today":
        return /* @__PURE__ */ A(De, {
          onClick: r,
          children: l.todayButtonLabel
        }, i);
      default:
        return null;
    }
  });
  return /* @__PURE__ */ A(Ft, g({}, a, {
    children: c
  }));
}
const uo = ["items", "changeImportance", "isLandscape", "onChange", "isValid"], fo = ["getValue"];
function mo(e) {
  const {
    items: t,
    changeImportance: n,
    onChange: o,
    isValid: r
  } = e, s = ae(e, uo);
  if (t == null || t.length === 0)
    return null;
  const a = t.map((l) => {
    let {
      getValue: c
    } = l, i = ae(l, fo);
    const u = c({
      isValid: r
    });
    return {
      label: i.label,
      onClick: () => {
        o(u, n, i);
      },
      disabled: !r(u)
    };
  });
  return /* @__PURE__ */ A(_t, g({
    dense: !0,
    sx: [{
      maxHeight: Pt,
      maxWidth: 200,
      overflow: "auto"
    }, ...Array.isArray(s.sx) ? s.sx : [s.sx]]
  }, s, {
    children: a.map((l) => /* @__PURE__ */ A(Wt, {
      children: /* @__PURE__ */ A(zt, g({}, l))
    }, l.label))
  }));
}
const po = (e) => {
  if (e !== void 0)
    return Object.keys(e).reduce((t, n) => g({}, t, {
      [`${n.slice(0, 1).toLowerCase()}${n.slice(1)}`]: e[n]
    }), {});
};
function ho(e) {
  return e.view !== null;
}
const go = (e) => {
  const {
    classes: t,
    isLandscape: n
  } = e;
  return Te({
    root: ["root", n && "landscape"],
    contentWrapper: ["contentWrapper"],
    toolbar: ["toolbar"],
    actionBar: ["actionBar"],
    tabs: ["tabs"],
    landscape: ["landscape"],
    shortcuts: ["shortcuts"]
  }, vt, t);
}, yo = (e) => {
  var t, n;
  const {
    wrapperVariant: o,
    onAccept: r,
    onClear: s,
    onCancel: a,
    onSetToday: l,
    view: c,
    views: i,
    onViewChange: u,
    value: v,
    onChange: C,
    onSelectShortcut: d,
    isValid: I,
    isLandscape: p,
    disabled: w,
    readOnly: h,
    children: y,
    components: m,
    componentsProps: S,
    slots: V,
    slotProps: b
    // TODO: Remove this "as" hack. It get introduced to mark `value` prop in PickersLayoutProps as not required.
    // The true type should be
    // - For pickers value: TDate | null
    // - For range pickers value: [TDate | null, TDate | null]
  } = e, T = V ?? po(m), R = b ?? S, P = go(e), H = (t = T == null ? void 0 : T.actionBar) != null ? t : co, k = ie({
    elementType: H,
    externalSlotProps: R == null ? void 0 : R.actionBar,
    additionalProps: {
      onAccept: r,
      onClear: s,
      onCancel: a,
      onSetToday: l,
      actions: o === "desktop" ? [] : ["cancel", "accept"],
      className: P.actionBar
    },
    ownerState: g({}, e, {
      wrapperVariant: o
    })
  }), z = /* @__PURE__ */ A(H, g({}, k)), B = T == null ? void 0 : T.toolbar, L = ie({
    elementType: B,
    externalSlotProps: R == null ? void 0 : R.toolbar,
    additionalProps: {
      isLandscape: p,
      onChange: C,
      value: v,
      view: c,
      onViewChange: u,
      views: i,
      disabled: w,
      readOnly: h,
      className: P.toolbar
    },
    ownerState: g({}, e, {
      wrapperVariant: o
    })
  }), Y = ho(L) && B ? /* @__PURE__ */ A(B, g({}, L)) : null, _ = y, U = T == null ? void 0 : T.tabs, O = c && U ? /* @__PURE__ */ A(U, g({
    view: c,
    onViewChange: u,
    className: P.tabs
  }, R == null ? void 0 : R.tabs)) : null, Z = (n = T == null ? void 0 : T.shortcuts) != null ? n : mo, G = ie({
    elementType: Z,
    externalSlotProps: R == null ? void 0 : R.shortcuts,
    additionalProps: {
      isValid: I,
      isLandscape: p,
      onChange: d,
      className: P.shortcuts
    },
    ownerState: {
      isValid: I,
      isLandscape: p,
      onChange: d,
      className: P.shortcuts,
      wrapperVariant: o
    }
  }), ue = c && Z ? /* @__PURE__ */ A(Z, g({}, G)) : null;
  return {
    toolbar: Y,
    content: _,
    tabs: O,
    actionBar: z,
    shortcuts: ue
  };
}, So = (e) => {
  const {
    isLandscape: t,
    classes: n
  } = e;
  return Te({
    root: ["root", t && "landscape"],
    contentWrapper: ["contentWrapper"]
  }, vt, n);
}, xt = ye("div", {
  name: "MuiPickersLayout",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => ({
  display: "grid",
  gridAutoColumns: "max-content auto max-content",
  gridAutoRows: "max-content auto max-content",
  [`& .${$e.toolbar}`]: t.isLandscape ? {
    gridColumn: e.direction === "rtl" ? 3 : 1,
    gridRow: "2 / 3"
  } : {
    gridColumn: "2 / 4",
    gridRow: 1
  },
  [`.${$e.shortcuts}`]: t.isLandscape ? {
    gridColumn: "2 / 4",
    gridRow: 1
  } : {
    gridColumn: e.direction === "rtl" ? 3 : 1,
    gridRow: "2 / 3"
  },
  [`& .${$e.actionBar}`]: {
    gridColumn: "1 / 4",
    gridRow: 3
  }
}));
xt.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  as: te.elementType,
  ownerState: te.shape({
    isLandscape: te.bool.isRequired
  }).isRequired,
  sx: te.oneOfType([te.arrayOf(te.oneOfType([te.func, te.object, te.bool])), te.func, te.object])
};
const Vo = ye("div", {
  name: "MuiPickersLayout",
  slot: "ContentWrapper",
  overridesResolver: (e, t) => t.contentWrapper
})({
  gridColumn: 2,
  gridRow: 2,
  display: "flex",
  flexDirection: "column"
}), Io = function(t) {
  const n = _e({
    props: t,
    name: "MuiPickersLayout"
  }), {
    toolbar: o,
    content: r,
    tabs: s,
    actionBar: a,
    shortcuts: l
  } = yo(n), {
    sx: c,
    className: i,
    isLandscape: u,
    ref: v,
    wrapperVariant: C
  } = n, d = n, I = So(d);
  return /* @__PURE__ */ pe(xt, {
    ref: v,
    sx: c,
    className: ke(i, I.root),
    ownerState: d,
    children: [u ? l : o, u ? o : l, /* @__PURE__ */ A(Vo, {
      className: I.contentWrapper,
      children: C === "desktop" ? /* @__PURE__ */ pe(f.Fragment, {
        children: [r, s]
      }) : /* @__PURE__ */ pe(f.Fragment, {
        children: [s, r]
      })
    }), a]
  });
};
function Cr(e, {
  disableFuture: t,
  maxDate: n,
  timezone: o
}) {
  const r = ce();
  return f.useMemo(() => {
    const s = r.dateWithTimezone(void 0, o), a = r.startOfMonth(t && r.isBefore(s, n) ? s : n);
    return !r.isAfter(a, e);
  }, [t, n, e, r, o]);
}
function Dr(e, {
  disablePast: t,
  minDate: n,
  timezone: o
}) {
  const r = ce();
  return f.useMemo(() => {
    const s = r.dateWithTimezone(void 0, o), a = r.startOfMonth(t && r.isAfter(s, n) ? s : n);
    return !r.isBefore(a, e);
  }, [t, n, e, r, o]);
}
function kr(e, t, n, o) {
  const r = ce(), s = an(e, r), a = f.useCallback((l) => {
    const c = e == null ? null : cn(e, l, !!t, r);
    n(c, o ?? "partial");
  }, [t, e, n, o, r]);
  return {
    meridiemMode: s,
    handleMeridiemChange: a
  };
}
const wo = ["ownerState"], br = ({
  clearable: e,
  fieldProps: t,
  InputProps: n,
  onClear: o,
  slots: r,
  slotProps: s,
  components: a,
  componentsProps: l
}) => {
  var c, i, u, v, C, d;
  const I = He(), p = (c = (i = r == null ? void 0 : r.clearButton) != null ? i : a == null ? void 0 : a.ClearButton) != null ? c : at, w = ie({
    elementType: p,
    externalSlotProps: (u = s == null ? void 0 : s.clearButton) != null ? u : l == null ? void 0 : l.clearButton,
    ownerState: {},
    className: "clearButton",
    additionalProps: {
      title: I.fieldClearLabel
    }
  }), h = ae(w, wo), y = (v = (C = r == null ? void 0 : r.clearIcon) != null ? C : a == null ? void 0 : a.ClearIcon) != null ? v : Rn, m = ie({
    elementType: y,
    externalSlotProps: (d = s == null ? void 0 : s.clearIcon) != null ? d : l == null ? void 0 : l.clearIcon,
    ownerState: {}
  }), S = g({}, n, {
    endAdornment: /* @__PURE__ */ pe(f.Fragment, {
      children: [e && /* @__PURE__ */ A(lt, {
        position: "end",
        sx: {
          marginRight: n != null && n.endAdornment ? -1 : -1.5
        },
        children: /* @__PURE__ */ A(p, g({}, h, {
          onClick: o,
          children: /* @__PURE__ */ A(y, g({
            fontSize: "small"
          }, m))
        }))
      }), n == null ? void 0 : n.endAdornment]
    })
  }), V = g({}, t, {
    sx: [{
      "& .clearButton": {
        opacity: 1
      },
      "@media (pointer: fine)": {
        "& .clearButton": {
          opacity: 0
        },
        "&:hover, &:focus-within": {
          ".clearButton": {
            opacity: 1
          }
        }
      }
    }, ...Array.isArray(t.sx) ? t.sx : [t.sx]]
  });
  return {
    InputProps: S,
    fieldProps: V
  };
}, Po = ["props", "getOpenDialogAriaText"], vo = ["ownerState"], xo = ["ownerState"], Er = (e) => {
  var t, n, o, r, s;
  let {
    props: a,
    getOpenDialogAriaText: l
  } = e, c = ae(e, Po);
  const {
    slots: i,
    slotProps: u,
    className: v,
    sx: C,
    format: d,
    formatDensity: I,
    timezone: p,
    name: w,
    label: h,
    inputRef: y,
    readOnly: m,
    disabled: S,
    autoFocus: V,
    localeText: b,
    reduceAnimations: T
  } = a, R = ce(), P = f.useRef(null), H = f.useRef(null), k = Xt(), z = (t = u == null || (n = u.toolbar) == null ? void 0 : n.hidden) != null ? t : !1, {
    open: B,
    actions: L,
    hasUIView: Y,
    layoutProps: _,
    renderCurrentView: U,
    shouldRestoreFocus: O,
    fieldProps: Z
  } = lo(g({}, c, {
    props: a,
    inputRef: P,
    autoFocusView: !0,
    additionalViewProps: {},
    wrapperVariant: "desktop"
  })), G = (o = i.inputAdornment) != null ? o : lt, ue = ie({
    elementType: G,
    externalSlotProps: u == null ? void 0 : u.inputAdornment,
    additionalProps: {
      position: "end"
    },
    ownerState: a
  }), ne = ae(ue, vo), oe = (r = i.openPickerButton) != null ? r : at, E = ie({
    elementType: oe,
    externalSlotProps: u == null ? void 0 : u.openPickerButton,
    additionalProps: {
      disabled: S || m,
      onClick: B ? L.onClose : L.onOpen,
      "aria-label": l(Z.value, R),
      edge: ne.position
    },
    ownerState: a
  }), N = ae(E, xo), j = i.openPickerIcon, x = i.field, $ = ie({
    elementType: x,
    externalSlotProps: u == null ? void 0 : u.field,
    additionalProps: g({}, Z, z && {
      id: k
    }, {
      readOnly: m,
      disabled: S,
      className: v,
      sx: C,
      format: d,
      formatDensity: I,
      timezone: p,
      label: h,
      name: w,
      autoFocus: V && !a.open,
      focused: B ? !0 : void 0
    }),
    ownerState: a
  });
  Y && ($.InputProps = g({}, $.InputProps, {
    ref: H
  }, !a.disableOpenPicker && {
    [`${ne.position}Adornment`]: /* @__PURE__ */ A(G, g({}, ne, {
      children: /* @__PURE__ */ A(oe, g({}, N, {
        children: /* @__PURE__ */ A(j, g({}, u == null ? void 0 : u.openPickerIcon))
      }))
    }))
  }));
  const q = g({
    textField: i.textField,
    clearIcon: i.clearIcon,
    clearButton: i.clearButton
  }, $.slots), Q = (s = i.layout) != null ? s : Io, J = be(P, $.inputRef, y);
  let X = k;
  z && (h ? X = `${k}-label` : X = void 0);
  const ee = g({}, u, {
    toolbar: g({}, u == null ? void 0 : u.toolbar, {
      titleId: k
    }),
    popper: g({
      "aria-labelledby": X
    }, u == null ? void 0 : u.popper)
  });
  return {
    renderPicker: () => /* @__PURE__ */ pe(Mt, {
      localeText: b,
      children: [/* @__PURE__ */ A(x, g({}, $, {
        slots: q,
        slotProps: ee,
        inputRef: J
      })), /* @__PURE__ */ A(jn, g({
        role: "dialog",
        placement: "bottom-start",
        anchorEl: H.current
      }, L, {
        open: B,
        slots: i,
        slotProps: ee,
        shouldRestoreFocus: O,
        reduceAnimations: T,
        children: /* @__PURE__ */ A(Q, g({}, _, ee == null ? void 0 : ee.layout, {
          slots: i,
          slotProps: ee,
          children: U()
        }))
      }))]
    })
  };
}, Tr = ye("div")({
  overflow: "hidden",
  width: Ln,
  maxHeight: Pt,
  display: "flex",
  flexDirection: "column",
  margin: "0 auto"
});
export {
  mr as $,
  Xt as A,
  lo as B,
  gr as C,
  Ln as D,
  lr as E,
  Io as F,
  be as G,
  ir as H,
  qo as I,
  yr as J,
  er as K,
  un as L,
  vr as M,
  Qn as N,
  ut as O,
  xr as P,
  Tr as Q,
  Pr as R,
  ge as S,
  Sr as T,
  ar as U,
  Pt as V,
  sr as W,
  F as X,
  no as Y,
  ln as Z,
  sn as _,
  ce as a,
  pr as a0,
  Vr as a1,
  Ir as a2,
  xe as a3,
  Pe as a4,
  Ce as a5,
  Zo as a6,
  Jo as a7,
  ct as a8,
  wr as a9,
  fr as aa,
  Cr as ab,
  Dr as ac,
  Bn as ad,
  Ne as ae,
  nr as b,
  or as c,
  ie as d,
  br as e,
  Me as f,
  We as g,
  He as h,
  kr as i,
  ke as j,
  En as k,
  Ko as l,
  Te as m,
  po as n,
  Qo as o,
  Yo as p,
  ur as q,
  tr as r,
  dr as s,
  Er as t,
  cr as u,
  jo as v,
  Xo as w,
  rr as x,
  Go as y,
  hr as z
};
